// 题目报错
export default {
    get_error_type: 'api/dict/selectByPage',
    add_report_error: 'api/questionReport/add'
}